<!-- @format -->

<div class="container" *transloco="let t">
  <fudis-heading [class]="'fudis-mt-md'" [level]="1">{{ t("ADD_TO_PLAN_WIZARD.TITLE") }}</fudis-heading>
  @if ({ step: this.progressStep | async }; as progress) {
    <sis-wizard-progress [currentStep]="progress.step" [stepKeys]="wizardProgressStepKeys" />
    @if (progress.step === 0) {
      <app-add-to-plan-wizard-select-destination-step
        class="add-to-plan-wizard"
        (next)="next()"
        (initPlanManager)="initPlanManager($event)"
        (setPlan)="setPlan($event)"
        [courseUnit]="courseUnit"
        [customCourseUnitAttainment]="customCourseUnitAttainment"
        [initialPlanId]="planId" />
    }
    @if (progress.step === 1) {
      <app-add-to-plan-wizard-preview-and-confirm-step (previous)="previous()" (confirm)="confirm()" />
    }
  }
</div>
